import db from '../../firebase/firebaseconfig'

import {setMessage} from '@/controllers/message.controller'
// import {create} from '@/controllers/admin.controller'

import router from '@/router'

const adminsRef = db.firestore().collection('admins')

// import AdminModel from '../models/admin.model'

import adminStore from "@/store/admin.store"



export const signinAdmin = async (email, password) => {
  try {
   const result = await db.auth().signInWithEmailAndPassword(email, password)

    if (!result) {
      return null
    }
   
    await getAdmin(email)

    router.push('/totem')
    
    return result
  } catch (error) {
    console.log(error)
    setMessage(error.code)
  }
}


export const getAdmin = async (email) => {

  try {
    const snapshot = await adminsRef.where('email', '==', email).get()

    if (snapshot.empty) {
      await createAdmin(email)
      return
    }
   
    const admin = { 
      id:snapshot.docs[0].id, 
      ...snapshot.docs[0].data() 
    };

    adminStore.commit('setAdmin', admin)


    return admin;


  } catch (error) {
    console.log(error)
  }
}

export const createAdmin = async (email) => {
  try {
     await adminsRef.doc().set({
      email: email,
    })

    getAdmin(email)
    
  } catch (error) {
    console.log(error)
  }
}

export const createLog = async (adminId, totemId) => {
   await db.firestore().collection('adminLog').add({
    date: new Date().toISOString(),
    adminId,
    totemId
  })

}

export const signOutDataBase = async () => {
  db.auth().signOut().then(() => {
    adminStore.commit('clearAdmin')

    router.push('/')
  }).catch(error => {
    console.log(error)
  })
}